import { render, staticRenderFns } from "./DerbyInfo.vue?vue&type=template&id=1f312358&scoped=true&"
import script from "./DerbyInfo.vue?vue&type=script&lang=js&"
export * from "./DerbyInfo.vue?vue&type=script&lang=js&"
import style0 from "./DerbyInfo.vue?vue&type=style&index=0&id=1f312358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f312358",
  null
  
)

export default component.exports